'use client'

import { useTranslations } from 'next-intl'
import { useState, type ChangeEvent, type KeyboardEvent } from 'react'

import { useRouter } from '@/shared/i18n'
import { cn, Slot } from '@/shared/lib'
import { Icon, TextField } from '@/shared/ui'

type Props = {
  className?: string
}

export const SearchBar = ({ className }: Props) => {
  const t = useTranslations('main')
  const router = useRouter()

  const [value, setValue] = useState('')

  const search = () => {
    router.push(`/guest/room?keyword=${value}`)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.nativeEvent.isComposing) return

    if (event.key === 'Enter') {
      event.preventDefault()
      search()
    }
  }

  return (
    <div
      className={cn(
        'gradient-border mobile shrink-0 shadow-[0px_4px_6px_0px_rgba(0,0,0,0.16)]',
        className,
      )}
    >
      <div className={cn('flex w-full items-center')}>
        <TextField
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={t('search.placeholder')}
          fullWidth
          className="typo-body2-reading h-[58px] rounded-full border-none"
          padding={{
            x: 24,
            y: 18,
          }}
        >
          <Slot name="right">
            <Icon
              name="search"
              size={24}
              strokeWidth={1.5}
              className="-mr-1 text-black"
            />
          </Slot>
        </TextField>
      </div>
    </div>
  )
}
